/* eslint-disable @next/next/no-img-element */
import React, { useEffect, useState } from 'react';
import { HeadLine } from '../../components/component';
import Meta from '../../components/Meta';
import FilterCategoryItem from '../../components/categories/filterCategoryItem';

const Explore_nfts = () => {
  return (
    <>
      <Meta title='Explore NFTs || Bit5 | Create. Collect. Connect.' />
      <section className='relative mt-0 pb-24 lg:pb-48'>
        <picture className='pointer-events-none absolute inset-0 -z-10 dark:hidden'>
          <img src='/images/gradient_light.jpg' alt='gradient' className='h-full' />
        </picture>

        <div className='px-2'>
          <HeadLine
            text='Explore NFTs'
            classes='font-display text-jacarta-700 py-16 text-center text-4xl font-medium dark:text-white'
          />
          {/* <!-- Grid --> */}
          <div>
            <FilterCategoryItem propertiesDisabled SortByIdDisabled visibleFloorSweep={false}/>
            {/*<Trending_categories_items foo={foo}/>*/}
            {/*<Explore_collection_item itemFor="explore-collection"/>*/}
          </div>
        </div>
      </section>
    </>
  );
};

export default Explore_nfts;
